import revive_payload_client_4sVQNw7RlN from "/vercel/path0/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/vercel/path0/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_MwZUzHrRNP from "/vercel/path0/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/vercel/path0/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/vercel/path0/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/vercel/path0/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/vercel/path0/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/vercel/path0/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/vercel/path0/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_tbFNToZNim from "/vercel/path0/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import plugin_client_LcKgStRyi6 from "/vercel/path0/node_modules/nuxt-gtag/dist/runtime/plugin.client.mjs";
import plugin_GLp6kzVXKq from "/vercel/path0/node_modules/nuxt-pdfeasy/dist/runtime/plugin.mjs";
import switch_locale_path_ssr_5csfIgkrBP from "/vercel/path0/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/vercel/path0/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import colors_IwJ62dYxig from "/vercel/path0/node_modules/.c12/github_robinrobinrobinrobin_the_f8jQ6p1Lip/plugins/colors.ts";
import dragscroll_ydZxRICbJX from "/vercel/path0/node_modules/.c12/github_robinrobinrobinrobin_the_f8jQ6p1Lip/plugins/dragscroll.ts";
import focus_spJ7QpzYFS from "/vercel/path0/node_modules/.c12/github_robinrobinrobinrobin_the_f8jQ6p1Lip/plugins/focus.ts";
import promotions_nTg2m0LcYG from "/vercel/path0/node_modules/.c12/github_robinrobinrobinrobin_the_f8jQ6p1Lip/plugins/promotions.ts";
import sentry_xGmtSAf3Pk from "/vercel/path0/node_modules/.c12/github_robinrobinrobinrobin_the_f8jQ6p1Lip/plugins/sentry.ts";
import sonner_client_CvUGEhvkC4 from "/vercel/path0/node_modules/.c12/github_robinrobinrobinrobin_the_f8jQ6p1Lip/plugins/sonner.client.ts";
import telinput_client_nIhqqWKo3I from "/vercel/path0/node_modules/.c12/github_robinrobinrobinrobin_the_f8jQ6p1Lip/plugins/telinput.client.ts";
import colors_SVBUrxEU7r from "/vercel/path0/plugins/colors.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_MwZUzHrRNP,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_tbFNToZNim,
  plugin_client_LcKgStRyi6,
  plugin_GLp6kzVXKq,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  colors_IwJ62dYxig,
  dragscroll_ydZxRICbJX,
  focus_spJ7QpzYFS,
  promotions_nTg2m0LcYG,
  sentry_xGmtSAf3Pk,
  sonner_client_CvUGEhvkC4,
  telinput_client_nIhqqWKo3I,
  colors_SVBUrxEU7r
]